import { ViewModelEntity } from '@view-model/domain/view-model';
import { Folder } from '@workspace/view-model-folder/domain/Folder';
import { KataSearchViewModelItem } from './KataSearchViewModelItem';
import { KataSearchFolderItem } from './KataSearchFolderItem';
import { useMemo } from 'react';
import { useAtomValue } from 'jotai';
import { filteredKataSearchRecordsAtom } from './kataSearchResultState';
import { sidebarSearchKeywordAtom } from '../sidebarSearchKeywordAtom';

export const KataSearchResult: React.FC = () => {
  const { workspaces, folders, viewModels, folderTrees } = useAtomValue(filteredKataSearchRecordsAtom);
  const searchKeyword = useAtomValue(sidebarSearchKeywordAtom);

  const workspace = useMemo(() => Object.values(workspaces)[0] ?? null, [workspaces]);

  const rootFolderTree = useMemo(() => {
    if (!workspace) return null;
    return folderTrees[workspace.id];
  }, [folderTrees, workspace]);

  const sortedFolders = useMemo(() => {
    if (!rootFolderTree) return [];

    return rootFolderTree
      .getFolderIdsOfRoot()
      .map((folderId) => folders[folderId])
      .filter((folder) => !!folder)
      .sort(Folder.compare);
  }, [rootFolderTree, folders]);

  const sortedViewModels = useMemo(() => {
    if (!rootFolderTree) return [];

    return rootFolderTree
      .getViewModelIdsOfRoot()
      .map((viewModelId) => viewModels[viewModelId])
      .filter((viewModel) => !!viewModel)
      .sort(ViewModelEntity.compare);
  }, [rootFolderTree, viewModels]);

  if (!workspace || !rootFolderTree || (sortedFolders.length === 0 && sortedViewModels.length === 0)) {
    return null;
  }

  return (
    <div>
      <div className="text-xs font-bold">KATA（Balus共通）</div>
      <div className="ml-4">
        <div>
          {sortedFolders.map((folder) => (
            <KataSearchFolderItem
              key={folder.id}
              workspace={workspace}
              rootFolderTree={rootFolderTree}
              folder={folder}
              searchKeyword={searchKeyword}
            />
          ))}
        </div>
        <div>
          {sortedViewModels.map((viewModel) => (
            <KataSearchViewModelItem
              key={viewModel.id}
              viewModel={viewModel}
              workspace={workspace}
              searchKeyword={searchKeyword}
            />
          ))}
        </div>
      </div>
    </div>
  );
};
